module.exports = __webpack_public_path__ + "static/media/PM18.d0f846a5.png";